export default __webpack_public_path__ + "static/media/hp_classic.1ebf01dd.png";